import { Component, OnInit, ViewChild } from '@angular/core';
import { PageSettingsModel, GridComponent, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { DatePipe } from '@angular/common';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService, ConversionMonedaService, MonedaService } from '../../../../src/app/shared/services/index';
import { ConversionMoneda, GridPageSettings, MenuFuncionCodes, Moneda, SearchConversionMonedaRequest, SearchMonedaRequest } from '../../../../src/app/shared/model';
import { ExportMediaTypeConstants } from '../../shared/model';

@Component({
  selector: 'app-monedaConversionList',
  templateUrl: './conversionList.component.html',
})
export class ConversionMonedaListComponent implements OnInit {

  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isMonedaSearching: boolean = false;

  canEdit: boolean = false;
  canView: boolean = false;
  canAdd: boolean = false;
  verSoloActivos: boolean = true;

  monedas: Moneda[];

  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private router: Router,
    private sharedFunctions: SharedFunctions,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private service: ConversionMonedaService,
    private monedaService: MonedaService,
    private menuService: MenuFuncionService
  ) {
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.MONEDA_CONVERSION).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result){
        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.MONEDA_CONVERSION_ADD);
        this.canView = data.Result.some(x => x == MenuFuncionCodes.MONEDA_CONVERSION_LIST);
        if (this.canView) {
          this.loadView();
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.router.navigate(['/']);
        }
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.canView = true;
    this.buildForm();

    this.getMonedas();

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });
  }

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'FechaCotizacionDesde': [null],
      'FechaCotizacionHasta': [null],
      'MonedaOrigenId': [null],
      'MonedaDestinoId': [null],
    });
  }

  getMonedas() {
    var search = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(search).subscribe(data => {
      this.isMonedaSearching = false;
      this.monedas = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.showMessage(err?.error?.Message ?? "Ocurrió un error intentando ejecutar la operación", "Error");
    })
  }

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "FechaCotizacionDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaCotizacionDesde,"yyyy-MM-dd");
    else
      this.query.addParams("FechaCotizacionDesde", this.datePipe.transform(this.searchForm.value.FechaCotizacionDesde,"yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaCotizacionHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaCotizacionHasta,"yyyy-MM-dd");
    else
      this.query.addParams("FechaCotizacionHasta", this.datePipe.transform(this.searchForm.value.FechaCotizacionHasta,"yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "MonedaOrigenId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MonedaOrigenId;
    else
      this.query.addParams("MonedaOrigenId", this.searchForm.value.MonedaOrigenId);

    index = this.query.params.findIndex(obj => obj.key === "MonedaDestinoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MonedaDestinoId;
    else
      this.query.addParams("MonedaDestinoId", this.searchForm.value.MonedaDestinoId);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.verSoloActivos.toString();
    else
      this.query.addParams("VerSoloActivos", this.verSoloActivos.toString());
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
        if (this.searchForm.get(formFieldName) != null && this.searchForm.get(formFieldName)?.value)
            this.searchForm.get(formFieldName)?.setValue(null);
    }
  }

  add() {
    if(this.canAdd){
      this.router.navigate(['moneda-conversion-edit', 0]);
    }
    else {
      this.sharedFunctions.showMessage("No tiene permisos para crear un nuevo item", "Error");
    }
  }

  edit(item: ConversionMoneda) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['moneda-conversion-edit', item.Id]);
  }

  onExport() {
    var search = new SearchConversionMonedaRequest(null, null, null, "", null, null, null, null, this.verSoloActivos);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "MonedaConversiones_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }
}
